<template>
  <div class="page_wrapper row p-0">
    <login-header @openModal="openModal"></login-header>
        <div class="col-sm-12 p-0 checkbox-success-section" v-if="successMessage">
            <div><img class="check-box-error-info" src="/static/images/icons/success-message-icon.svg" /></div>
              <div class="checkbox-success" v-if="successMessage && !flag">
                <p  class="m-0" v-html="successMessage"></p>
              </div>
              <div class="checkbox-success" v-if="successMessage && flag">
                <p class="m-0" v-html="successMessagePart1"></p>
                <p v-html="successMessagePart2" @click.prevent="goToVerificationLinkPage" class="link m-0"></p>
              </div>
            <div><img class="chechBox-error-cancel-icon" src="/static/images/icons/chechBox-error-cancel-icon.png" @click="closeSuccessTopBannerMessages" /></div>
      </div>
        <div class="col-sm-12 p-0 checkbox-error-section" v-if="errorMessage">
            <div><img class="check-box-error-info" src="/static/images/icons/check-box-error-info.png" /></div>
                <p v-html="errorMessage" class="m-0 checkbox-error"></p>
            <div><img class="chechBox-error-cancel-icon" src="/static/images/icons/chechBox-error-cancel-icon.png" @click="closeErrorTopBannerMessages" /></div>
      </div>
    <main class="col-xs-12 p-0">
      <div class="col-xs-12 p-0 d-flex justify-content-center">
        <div class="login-whitebox">
          <form @submit.prevent="loginUser">
            <p class="page_header pt-20">{{$t('welcomeMessagePart1')}}<br/><span class="pt-3">Conformity Declaration Management by UL Solutions<span class="reserved">&#174;</span></span></p>
            <p class="login-card-desc">{{$t('loginDesc')}}</p>
            <div class="login-container mb-8">
              <div class="login-input">
                <label for="email" class="float-left mb-0">{{$t('email')}}</label>
                <span class="required_astric">*</span>
                <input
                  class="login-input-box-without-icon landing-input-field form-control"
                  type="text"
                  name="email"
                  :placeholder="$t('enterEmail')"
                  v-model="email"
                  :class="{ 'field_error': errorMessage }"
                />
              </div>
            </div>
            <div class="login-container pt-28">
              <div class="login-input">
                <label for="password" class="float-left mb-0">{{$t('password')}}</label>
                <span class="required_astric">*</span>
                <input
                  id="password"
                  class="login-input-box-without-icon landing-input-field form-control"
                  type="password"
                  name="password"
                  :placeholder="$t('enterPassword')"
                  v-model="password"
                  :class="{ 'field_error': errorMessage }"
                />
                <span>
                  <img v-if="showPassword"
                      src="/static/images/icons/eye_icon_ul.svg"
                      alt="eye-image"
                      id="togglePassword"
                      @click="switchVisibility()"
                      />
                      <img
                      v-if="!showPassword"
                      src="/static/images/icons/show_password_icon.svg"
                      alt="eye-slash-image"
                      id="togglePassword"
                      @click="switchVisibility()"
                      />
                  </span>
              </div>
            </div>
            <div class="row mr-0 ml-0 rememberMe-container">
              <div class="col-xs-12 col-sm-6 col-md-6 p-0">
                <div class="d-flex checkbox-container cust_checkbox">
                  <input type="checkbox"
                    class="checkbox-register"
                    @click="setCookie"
                  />
                  <label></label>
                  <div class="remember-me">{{$t('rememberMe')}}</div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 p-0 text-align forgot-link">
                  <router-link to="/forgot" class="link-text-login font-bold font-18">{{$t('forgotPassword')}}?</router-link>
              </div>
            </div>
            <!-- <div class="alert validation-danger" v-if="errorMessage">
                <p v-html="errorMessage"></p>
              </div> -->
              <!-- <div class="alert alert-success" v-if="successMessage && !flag">
                <p v-html="successMessage"></p>
              </div>
              <div class="alert alert-success" v-if="successMessage && flag">
                <p v-html="successMessagePart1"></p>
                <p v-html="successMessagePart2" @click.prevent="goToVerificationLinkPage" class="link"></p>
              </div> -->
            <div class="login-btn" :class="{'pt-32' : successMessage || errorMessage}">
              <button
                class="btn button-success"
                :disabled="disableSubmit || disableFormSubmit"
                type="submit"
              >
              <span class="login-text">{{$t('login')}}</span>
              </button>
            </div>
            <!-- <div class="text-center forgot-link">
              <router-link to="/forgot" class="link-text-login font-bold font-18"
                >{{$t('forgotPassword')}}?</router-link
              >
            </div> -->
            <div class="create-account-fonts text-center">
              {{$t('doNotHaveAccount')}}?
              <router-link to="/register" class="link-text-login font-bold font-18"
                >{{$t('createAccount')}}</router-link
              >
            </div>
          </form>
        </div>
      </div>
    </main>
      <login-footer @openModal="openModal"></login-footer>
      <TermsOfStatus :termsOfStatus="agreementType"></TermsOfStatus>
  </div>
</template>
<script>
import $ from 'jquery';
import { loginUser } from '../../apis/login';
import { getCookie } from '../../utils/common';
import LoginHeader from './LoginHeaderNew.vue';
import LoginFooter from './LoginFooterNew.vue';
import TermsOfStatus from './TermsOfStatus.vue';
import {
  postLanguagePreference,

} from '../../apis/languagePreferences';
import EventBus from '../../utils/event-bus';

export default {
  data() {
    return {
      showPassword: true,
      agreementType: '',
      successMessagePart1: '',
      successMessagePart2: '',
      email: '',
      password: '',
      selectedAccount: '',
      accountList: [],
      errorMessage: '',
      LoginButton: 'Log in',
      successMessage: '',
      disableFormSubmit: false,
      flag: false,
    };
  },
  components: {
    TermsOfStatus,
    LoginHeader,
    LoginFooter,
  },
  created() {
    if (this.$route.params.successMessage) {
      this.successMessage = this.$route.params.successMessage;
      if (this.$i18n.locale === 'Portuguese') {
        if (this.successMessage === 'Your account is already confirmed') this.successMessage = 'Sua conta já está confirmada';
        else if (this.successMessage === 'Your password has been set, please log in to access Conformity Declaration Management') this.successMessage = 'Sua senha foi definida, faça login para acessar o Conformity Declaration Management';
        else if (this.successMessage === 'Your account is confirmed, please login now') this.successMessage = 'Sua conta foi confirmada, faça o login agora';
        else if (this.successMessage === 'Didn\'t receive your verification email?<br/><a class="link" href="/verificationlink">Get a new link sent</a>') this.successMessage = 'Não recebeu seu e-mail de verificação?<br/><a class="link" href="/verificationlink">Receber um novo link enviado</a>';
        else if (this.successMessage === 'Password Changed Successfully.') this.successMessage = 'Senha alterada com sucesso.';
      }
    }
    EventBus.$on('languageChanged', (data) => {
      if (data === 'Portuguese') {
        if (this.successMessage === 'Your account is already confirmed') this.successMessage = 'Sua conta já está confirmada';
        else if (this.successMessage === 'Your password has been set, please log in to access Conformity Declaration Management') this.successMessage = 'Sua senha foi definida, faça login para acessar o Conformity Declaration Management';
        else if (this.successMessage === 'Please confirm your account. A confirmation email has been sent to your registered email') this.successMessage = 'Por favor, confirme sua conta. Um e-mail de confirmação foi enviado para o seu e-mail cadastrado';
        else if (this.successMessage === 'Your account is confirmed, please login now') this.successMessage = 'Sua conta foi confirmada, faça o login agora';
        else if (this.successMessage === 'Didn\'t receive your verification email?<br/><a class="link" href="/verificationlink">Get a new link sent</a>') this.successMessage = 'Não recebeu seu e-mail de verificação?<br/><a class="link" href="/verificationlink">Receber um novo link enviado</a>';
        else if (this.successMessage === 'A confirmation email has been sent') this.successMessage = 'Um e-mail de confirmação foi enviado';
        if (this.errorMessage === 'Your account has been deactivated.') this.errorMessage = 'Sua conta foi desativada.';
        else if (this.errorMessage === 'Invalid email and/or password' || this.errorMessage === 'Invalid email and/or password.') this.errorMessage = 'E-mail e/ou senha inválidos';
        else if (this.errorMessage === 'Account set up incomplete.Establish your password via the Forgot your password link above') this.errorMessage = 'Conta configurada incompleta. Estabeleça sua senha através do link Esqueceu sua senha acima';
        else if (this.errorMessage === 'Token has expired. Confirm your account via the Forgot your password link below.') this.errorMessage = 'O token expirou. Confirme sua conta através do link Esqueceu sua senha abaixo.';
        else if (this.successMessage === 'Password Changed Successfully.') this.successMessage = 'Senha alterada com sucesso.';
      }
      if (data === 'English') {
        if (this.successMessage === 'Sua conta já está confirmada') this.successMessage = 'Your account is already confirmed';
        else if (this.successMessage === 'Sua senha foi definida, faça login para acessar o Conformity Declaration Management') this.successMessage = 'Your password has been set, please log in to access Conformity Declaration Management';
        else if (this.successMessage === 'Por favor, confirme sua conta. Um e-mail de confirmação foi enviado para o seu e-mail cadastrado') this.successMessage = 'Please confirm your account. A confirmation email has been sent to your registered email';
        else if (this.successMessage === 'Sua conta foi confirmada, faça o login agora') this.successMessage = 'Your account is confirmed, please login now';
        else if (this.successMessage === 'Não recebeu seu e-mail de verificação?<br/><a class="link" href="/verificationlink">Receber um novo link enviado</a>') this.successMessage = 'Didn\'t receive your verification email?<br/><a class="link" href="/verificationlink">Get a new link sent</a>';
        else if (this.successMessage === 'Um e-mail de confirmação foi enviado') this.successMessage = 'A confirmation email has been sent';
        if (this.errorMessage === 'Sua conta foi desativada.') this.errorMessage = 'Your account has been deactivated.';
        else if (this.errorMessage === 'E-mail e/ou senha inválidos') this.errorMessage = 'Invalid email and/or password';
        else if (this.errorMessage === 'Conta configurada incompleta. Estabeleça sua senha através do link Esqueceu sua senha acima') this.errorMessage = 'Account set up incomplete.Establish your password via the Forgot your password link above';
        else if (this.errorMessage === 'O token expirou. Confirme sua conta através do link Esqueceu sua senha abaixo.') this.errorMessage = 'Token has expired. Confirm your account via the Forgot your password link below.';
        else if (this.successMessage === 'Senha alterada com sucesso.') this.successMessage = 'Password Changed Successfully.';
      }
      if (this.successMessage === 'Didn\'t receive your verification email?<br/><a class="link" href="/verificationlink">Get a new link sent</a>' || this.successMessage === 'Não recebeu seu e-mail de verificação?<br/><a class="link" href="/verificationlink">Receber um novo link enviado</a>') {
        this.translateSuccessMessage();
      }
    });
    if (this.$route.params.errorMessage) {
      this.errorMessage = this.$route.params.errorMessage;
    }
    this.email = getCookie('email');
    this.password = getCookie('password');
    if (this.successMessage === 'Didn\'t receive your verification email?<br/><a class="link" href="/verificationlink">Get a new link sent</a>' || this.successMessage === 'Não recebeu seu e-mail de verificação?<br/><a class="link" href="/verificationlink">Receber um novo link enviado</a>') {
      this.translateSuccessMessage();
    }
  },
  computed: {
    disableSubmit() {
      if (this.email && this.password) {
        return false;
      }
      return true;
    },
  },
  methods: {
    closeSuccessTopBannerMessages() {
      this.successMessage = '';
    },
    closeErrorTopBannerMessages() {
      this.errorMessage = '';
    },
    openModal(data) {
      this.agreementType = data;
      $('#agreements').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    translateSuccessMessage() {
      if (this.successMessage === 'Não recebeu seu e-mail de verificação?<br/><a class="link" href="/verificationlink">Receber um novo link enviado</a>') {
        this.successMessagePart1 = 'Não recebi seu e-mail de verificação?<br/>';
        this.successMessagePart2 = '<span>Obter um novo link enviado</span>';
      } else if (this.successMessage === 'Didn\'t receive your verification email?<br/><a class="link" href="/verificationlink">Get a new link sent</a>') {
        this.successMessagePart1 = 'Didn\'t receive your verification email?<br/>';
        this.successMessagePart2 = '<span>Get a new link sent</span>';
      }
      this.flag = true;
    },
    goToVerificationLinkPage() {
      // this.translateSuccessMessage();
      this.$router.push('/verificationlink');
      this.flag = false;
      // EventBus.$emit('languageChanged', this.$i18n.locale);
    },
    switchVisibility() {
      this.showPassword = !this.showPassword;
      const passwordField = document.querySelector('#password');
      if (passwordField.getAttribute('type') === 'password') {
        passwordField.setAttribute('type', 'text');
      } else {
        passwordField.setAttribute('type', 'password');
      }
    },
    setCookie() {
      const [email, password] = [this.email, this.password];

      document.cookie = `email=${email};path=${process.env.VUE_API_URL}`;
      document.cookie = `password=${password};path=${process.env.VUE_API_URL}`;
    },
    getFormData() {
      return {
        email: this.email,
        password: this.password,
      };
    },
    getRepCltFormData() {
      return {
        email: this.email,
        password: this.password,
        account_id: this.selectedAccount.account_id,
        role_id: this.selectedAccount.role_id,
        company_name: this.selectedAccount.company_name,
      };
    },
    async loginUser() {
      if (getCookie('Authorization')) {
        this.redirectUrl();
        return;
      }
      const formData = this.getFormData();
      this.disableFormSubmit = true;
      this.LoginButton = 'Logging in...';
      this.errorMessage = '';
      this.successMessage = '';
      const responseData = await loginUser(formData);
      if (!responseData) {
        this.LoginButton = 'Log in';
        this.disableFormSubmit = false;
      } else if (responseData && responseData.status === true) {
        this.errorMessage = '';
        localStorage.setItem('roleId', responseData.role_id);
        localStorage.setItem('userId', responseData.user_id);
        localStorage.setItem('accountId', responseData.account_id);

        const payload = { language: '' };
        payload.language = this.$i18n.locale === 'Portuguese' ? 'pt-BR' : 'en-US';
        const result = await postLanguagePreference(payload);

        if (result && result.status_code === 200) {
          this.$i18n.locale = payload.language === 'pt-BR' ? 'Portuguese' : 'English';
          localStorage.setItem('language', this.$i18n.locale);
        }
        this.redirectUrl(responseData.role_id);
      } else if (responseData.status === 'invalid') {
        this.LoginButton = 'Log in';
        this.disableFormSubmit = false;
        this.errorMessage = responseData.message;
        if (this.$i18n.locale === 'Portuguese') {
          if (this.errorMessage === 'Your account has been deactivated.') this.errorMessage = 'Sua conta foi desativada.';
          else if (this.errorMessage === 'Invalid email and/or password' || this.errorMessage === 'Invalid email and/or password.') this.errorMessage = 'E-mail e/ou senha inválidos';
          else if (this.errorMessage === 'Account set up incomplete.Establish your password via the Forgot your password link above') this.errorMessage = 'Conta configurada incompleta. Estabeleça sua senha através do link Esqueceu sua senha acima';
          else if (this.errorMessage === 'Token has expired. Confirm your account via the Forgot your password link below.') this.errorMessage = 'O token expirou. Confirme sua conta através do link Esqueceu sua senha abaixo.';
        }
        if (this.$i18n.locale === 'English') {
          if (this.errorMessage === 'Sua conta foi desativada.') this.errorMessage = 'Your account has been deactivated.';
          else if (this.errorMessage === 'E-mail e/ou senha inválidos') this.errorMessage = 'Invalid email and/or password';
          else if (this.errorMessage === 'Conta configurada incompleta. Estabeleça sua senha através do link Esqueceu sua senha acima') this.errorMessage = 'Account set up incomplete.Establish your password via the Forgot your password link above';
          else if (this.errorMessage === 'O token expirou. Confirme sua conta através do link Esqueceu sua senha abaixo.') this.errorMessage = 'Token has expired. Confirm your account via the Forgot your password link below.';
        }
      } else if (responseData.status === false) {
        let list = responseData.data ? responseData.data : [];
        if (this.email.toLowerCase() === 'lst.aus.rams-tracksupport@ul.com') {
          list = list.filter((item) => item.account_id !== 337);
        }
        this.accountList = list;
        this.selectedAccount = this.accountList.length
          ? this.accountList[0]
          : '';
        this.LoginButton = 'Log in';
        this.disableFormSubmit = false;
        $('#repAccountListModal').modal('toggle');
      }
    },
    async redirectUrl(roleId) {
      const redirectUrl = getCookie('redirect_url');
      if (redirectUrl) {
        document.cookie = 'redirect_url=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
        window.location.href = redirectUrl;
      } else if (roleId === 11) this.$router.push('/layout/launchpad');
      else this.$router.push('/layout/dashboard');
    },
  },
};
</script>
<style scoped>
.checkbox-error-section{
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #C01B21;
  margin-bottom: 16px;
}
.checkbox-error{
    padding: 7px 0px 7px 0px;
    background: #C01B21;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color:  #FFFFFF;
}

.checkbox-success-section{
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #146600;
  margin-bottom: 16px;
}
.checkbox-success{
    padding: 7px 0px 7px 0px;
    background: #146600;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color:  #FFFFFF;

}
.check-box-error-info{
  width: 20px;
  height: 20px;
  margin: 6px 0px 6px 16px;
}
.chechBox-error-cancel-icon{
  margin-right: 16px;
  cursor: pointer;
}
.form-control::placeholder {
 font-weight: 400;
font-size: 16px;
line-height: 22px;
color: #999999;
}
.pt-3{
  padding-top:3px
}
.link {
  font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color:  #FFFFFF !important;
  cursor: pointer;
    text-decoration: underline;
    padding-left:68px
}
.mr-0{
  margin-right: 0px !important;
}
.rememberMe-container{
  display: flex;
  align-items: center;
  margin-top: 23px;
  padding-left: 39px;
  padding-right: 38px;
}
.remember-me{
  margin-bottom: 0px;
  margin-top: -2px;
  margin-left: 14px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
}
input[type="checkbox"] {
  opacity: 0;
  cursor: pointer;
  position: absolute;
  z-index: 1;
  width: 39px !important;
  height: 24px !important;
  left: 2px;
  top: 0;
  margin: 0 !important;
}
.checkbox-container{
  position:relative;
}
.checkbox-container label {
  cursor: pointer;
  /* top: 9px; */
  position: relative;
  /* margin-top: 23px; */
  margin-bottom: 0px;
  padding-right: 0px;
}
.checkbox-container label:before{
  content: "";
  width: 18px !important;
  height: 18px !important;
  border: 2px solid #000000;
  /* border-radius: 1px; */
  display: inline-block;
  position: absolute;
  right: -2px;
  top: 0;
  border-radius: 3px;
}
.checkbox-container .checkbox-register{
  max-width: 18px;
  width: 18px;
  height: 18px;
  max-height: 18px;
  position:relative;
  /* top: 32px; */
  background: #000000 !important;
  accent-color:  #000000 !important;
  border: 2px solid #000000;
  border-radius: 3px;
}
.checkbox-container input[type="checkbox"]:checked + label:before {
  background-color: #4D4D4D;
  border:2px solid #4D4D4D;
  background-image: url(/static/images/icons/checkbox.svg);
  background-size: 15px 13px;
  background-repeat: no-repeat;
  background-position-x: center;
  border-radius: 3px;
}
.btn[disabled] {
  /* opacity: 1; */
  cursor: not-allowed;
  -webkit-box-shadow: none;
  box-shadow: none;
  background-color: rgba(1, 81, 138, 0.5) !important;
  /* border-color: rgba(1, 81, 138, 0.5) !important; */
  border:none !important;
}
.pt-32{
  padding-top: 32px !important;
}
.pt-32{
  padding-top: 28px !important;
}
.login-btn {
  padding: 23px 37px 32px 38px;
}
.login-text {
  font-size: 18px;
}
.mb-8 {
  margin-bottom: 10px;
}
.forgot-link{
  /* padding-bottom: 24px; */
  /* margin-top: 12px; */
  text-align:end;
}
.login-container {
  padding: 28px 37px 0 37px;
}
input::placeholder {
   font-weight: 400;
 font-size: 16px;
line-height: 22px;
color: #999999;
}
.page_wrapper {
  margin-left: 0px;
  margin-right: 0px;
  position: relative;
    padding-bottom: 62px;
    min-height: 100vh;
    /* background-image: url('/static/images/logos/login_page_header_blur.svg'); */
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top;
    overflow-x: hidden;
     background: #ebebeb;
}
main {
  padding: 30px 20px;
  /* background:#D5D5D5 */
}
.justify-content-center {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.login-whitebox {
  display: inline-block;
  margin-top: 72px;
  margin-bottom: 73px;
  padding: 10px;
  background:#FFFFFF;;
  /* box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25); */
  /* border-radius: 10px; */
  max-width: 684px;
  min-height: 703px;
  border: 1px solid #B3B3B3;
}
.page_header {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-size: 42px;
  line-height: 57px;
  padding: 54px 71px 0 72px;
  text-align: center;
  color: #333333;
}
.login-card-desc {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  margin-top: 24px;
  margin-bottom: 19px;
  line-height: 27px;
  text-align: center;
  color: #333333;
}

label {
    font-weight: 400;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    color: #3e3e3e;
    line-height: 22px;
    padding-right: 4px;
    padding-bottom: 7px;
}
.login-input input:focus{
  outline:none !important;
  outline-width: 0 !important;
  box-shadow: none;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  border: 1px solid #0A99FF;
}
.required_astric{
  color: #B00505;
  font-size: 16px;
}
.landing-input-field {
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 3px;
  border: 1px solid #4D4D4D;
  font-family: 'Open Sans' !important;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #4d4d4d;
}
.login-input-box-without-icon {
  padding: 5px 11px;
}
#togglePassword {
    cursor: pointer;
    float: right;
    position: absolute;
    /* top: -29px;
    right: 16px; */
    bottom:5px;
    right: 53px;
}
.validation-danger {
    margin-bottom: 0px;
    margin-top: 33px;
    margin-left: 72px;
    margin-right: 71px;
    padding-left: 8px;
    padding-top: 12px;
    padding-bottom: 12px;
    line-height: 16px;
    border: none;
    border-radius: 0px;
    /* background-color:  rgba(176, 5, 5, 0.1); */
}
.validation-danger p{
  text-align: center;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400 !important;
  font-size: 14px;
  font-family: 'Open Sans';
  color: #E12D33;
  line-height: 19px;
}
.alert-success {
    padding-left: 8px;
    margin-top: 33px;
    margin-left: 72px;
    margin-right: 71px;
    margin-bottom: 0px;
    padding-top: 12px;
    padding-bottom: 12px;
    border: none;
    border-radius: 0px;
    background-color:  rgba(66, 136, 59, 0.15);;
}
.alert-success p{
  text-align: center;
  font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400 !important;
    font-size: 12px;
    font-family: 'Open Sans';
    color: #333333;
}
.validation {
    /* margin-bottom: 13px; */
    /* padding: px 10px; */
    border: none;
    border-radius: 0px;
    padding-top:9px;
    padding-bottom: 12px;
}
.validation-danger {
    background-color: none !important;
    color:  #E12D33;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400 !important;
    font-size: 14px;
    line-height: 19px;

}
.btn {
    padding:10px 0px 9px 0px;
    font-size: 18px;
    font-weight: 600;
    line-height:25px;
    width: 100%;
    border-radius: 3px;
    background-color: #01518A !important;
    /* border-color: #01518A !important; */
    color: #FFFFFF !important;
}
.btn[disabled] {
  opacity: 1;
  cursor: not-allowed;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.button-success[disabled]:hover{
   background-color: rgba(1, 81, 138, 0.5) !important;
  border-color: rgba(1, 81, 138, 0.5) !important;
}
.button-success:hover{
  background-color: #01518A !important;
  border-color: #01518A !important;
}
.link-text-login {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;
    margin-left: 8px;
    text-align: center;
    color: #00518A;
}
.create-account-fonts{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  padding-bottom: 67px;
  color: #333333;
}
.pr-40 {
  padding-right: 40px;
}
.pl-40 {
  padding-left: 40px;
}
.pb-40 {
  padding-bottom: 40px;
}
/* @media screen and (max-width: 640px) {
  .login-whitebox {
    min-width: 90vw;
    margin-bottom: 10px;
  }
   .page_header{
    padding-left: 43px;
    padding-right: 43px;
    padding-top: 40px
  }
  .login-card-desc{
    padding-left: 40px;
    padding-right: 40px;
  }
  .login-container{
    padding-right: 32px;
    padding-left: 31px;
  }
  .login-btn{
    padding-right: 32px;
    padding-left: 31px;
  }
  .create-account-fonts{
    padding-right: 40px;
    padding-left: 40px;
  }
} */
.mb-30 {
  margin-bottom: 30px;
}
.mt-30 {
  margin-top: 30px;
}
.mr-tp-15 {
  margin-top: 15px;
}
.p-10 {
  padding: 10px;
}
/* @media only screen and (max-width: 991px) {
  #repAccountListModal > .modal-dialog {
    width: 95%;
    margin: 0px;
  }
}
@media screen and (max-width: 640px) {
  .p-40 {
    padding: 0;
  }
} */
/* @media screen and (min-width: 375px) and (max-width: 1024px) {
  .login-whitebox {
    margin-top: 66px;
  }
} */
</style>
